<div>
	<nz-table
		#table
		[nzShowPagination]="true"
		[nzFrontPagination]="true"
		[nzPageSize]="pageSize()"
		[nzTotal]="rows.length"
		[nzData]="rows()"
		[nzLoading]="loading()"
		[nzBordered]="false"
		nzSize="middle"
		(nzPageIndexChange)="onPageIndexChange($event)"
	>
		<thead>
			<tr>
				@for (column of columns(); track $index) {
					<th
						[nzSortOrder]="column.sortOrder ? column.sortOrder : null"
						[nzSortFn]="column.sortFn ? column.sortFn : null"
						[nzSortDirections]="column.sortDirections ? column.sortDirections : ['ascend', 'descend', null]"
						[nzShowSort]="column.sortFn ? true : false"
						[nzShowFilter]="column.filterOptions ? true : false"
						[nzFilterMultiple]="column.filterMultiple ? column.filterMultiple : false"
						[nzFilters]="column.filterOptions ? column.filterOptions : []"
						[nzFilterFn]="column.filterFn ? column.filterFn : null"
					>
						<ng-container *ngTemplateOutlet="headerMap.get(column.key)"></ng-container>
					</th>
				}
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			@for (row of table.data; track $index) {
				<tr class="row" [ngClass]="[row === selectedRow() ? 'selected' : '']">
					@for (column of columns(); track $index) {
						<td>
							<ng-container
								*ngTemplateOutlet="cellMap.get(column.key); context: { $implicit: row, row: row }"
							></ng-container>
						</td>
					}
					<td>
						<div class="buttons">
							@if (enableEditButton() && (row.before || row.after)) {
								<button nz-button nzType="primary" (click)="onEditClick(row)">Edit</button>
							}
							@if (
								enableToggleDisableButton() &&
								((row.after &&
									$any(row.after).active !== undefined &&
									$any(row.after).active !== null) ||
									(row.before &&
										$any(row.before).active !== undefined &&
										$any(row.before).active !== null))
							) {
								<button nz-button nzType="default" (click)="onToggleDisableClick(row)">
									@let beforeAfter = row.after || row.before;
									{{
										beforeAfter &&
										$any(beforeAfter).active !== undefined &&
										$any(beforeAfter).active !== null &&
										$any(beforeAfter).active === true
											? 'Disable'
											: 'Enable'
									}}
								</button>
							}
							@if (enableRemoveButton() && !row.before && row.after) {
								<button
									nz-button
									nzType="default"
									nz-popconfirm
									nzPopconfirmTitle="Are you sure you want to remove this item?"
									nzPopconfirmPlacement="bottom"
									(nzOnConfirm)="onRemoveClick(row)"
								>
									Remove
								</button>
							}
							@if (
								enableResetButton() &&
								row.before &&
								row.after &&
								JSON.stringify(row.before) !== JSON.stringify(row.after)
							) {
								<button
									nz-button
									nzType="default"
									nz-popconfirm
									nzPopconfirmTitle="Are you sure you want to reset this item?"
									nzPopconfirmPlacement="bottom"
									(nzOnConfirm)="onResetClick(row)"
								>
									Reset
								</button>
							}
							<ng-container
								*ngTemplateOutlet="actionsTemplate; context: { $implicit: row }"
							></ng-container>
						</div>
					</td>
				</tr>
			}
		</tbody>
	</nz-table>
</div>
